import { useRouter } from 'next/router'
import type { Dispatch, SetStateAction } from 'react'

import logger from '@/utils/logger'

import { ALL_TOPICS } from '@/components/CourseFinder'

export function useQueryCourses(): string[] {
  const router = useRouter()

  if (typeof router.query.course === 'undefined' || router.query.course === ALL_TOPICS) {
    return []
  }
  if (Array.isArray(router.query.course)) {
    return router.query.course
  }
  return [router.query.course]
}

export function useUpdateSelectedCourses(
  setDisableFilter: Dispatch<SetStateAction<boolean>>
): (selected: string[]) => void {
  const router = useRouter()

  return function updateSelectedCourses(selected: string[]) {
    setDisableFilter(true)
    router
      .replace({
        query: {
          ...router.query,
          course: selected,
        },
      })
      .catch(err => {
        logger.error('Navigation failed', { err })
      })
      .finally(() => setDisableFilter(false))
  }
}
